import { useQuery } from "react-query";
import axios from "infra/http";

function useTags() {
  return useQuery(
    "/v1/tags",
    async () => {
      const res = await axios.get<{ id: string; nome: string }[]>("/v1/tags");

      return res.data;
    },
    {
      cacheTime: Infinity,
      staleTime: Infinity,
    }
  );
}

export default useTags;
